import {
    Connection, PROGRESS, ERRORS, PERMISSION_ERROR,
} from '@iobroker/socket-client';

export { PROGRESS, ERRORS, PERMISSION_ERROR };

export default Connection;
